export const LENS_OPTIONS = [
  { value: "analytical", label: "Analytical", description: "Focused on data and facts" },
  { value: "creative", label: "Creative", description: "Imaginative and innovative" },
  { value: "critical", label: "Critical", description: "Questioning and evaluative" },
  { value: "practical", label: "Practical", description: "Solution-oriented" },
  { value: "empathetic", label: "Empathetic", description: "Understanding and supportive" },
  { value: "strategic", label: "Strategic", description: "Long-term planning" },
] as const;

export const SPECIALTY_OPTIONS = [
  { value: "research", label: "Research" },
  { value: "writing", label: "Writing" },
  { value: "coding", label: "Coding" },
  { value: "strategy", label: "Strategy" },
  { value: "learning", label: "Learning" },
] as const;

export const OUTPUT_FORMAT_OPTIONS = [
  { value: "text", label: "Plain text" },
  { value: "markdown", label: "Markdown" },
  { value: "json", label: "JSON" },
  { value: "list", label: "Bulleted list" },
] as const;

export const ICON_OPTIONS = ["🤖", "🧠", "💡", "📚", "🎯", "⚡", "🔬", "✨", "🎨", "📊", "🔧", "🌟"];

export function getLensLabel(value: string | null | undefined): string {
  if (!value) return "None";
  const option = LENS_OPTIONS.find((o) => o.value === value);
  return option?.label || value;
}
